import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './MapNoteSheetEditable.module.scss';

const MapNoteChangesButtons = props => {
    const saveButtonStyling = classNames(s.saveButton, s.button, props.isEnabled ? s.enabled : s.disabled);
    const cancelButtonStyling = classNames(s.cancelButton, s.removeButtonStyling);
    const onSave = props.isEnabled ? props.onSave : () => {};
    return (
        <div className={s.changesButtons}>
            <button data-testid="save-map-note-button" className={saveButtonStyling} type="button" onClick={onSave}>
                Save Changes
            </button>
            <button className={cancelButtonStyling} type="button" onClick={props.onCancel}>
                Cancel
            </button>
        </div>
    );
};

MapNoteChangesButtons.propTypes = {
    isEnabled: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
MapNoteChangesButtons.defaultProps = { isEnabled: false };

export default MapNoteChangesButtons;
